/** Generate by swagger-axios-codegen */
// tslint:disable
/* eslint-disable */

// Add options interface

// Add default options
export const serviceOptions = {};

// Instance selector
export function axios(configs, resolve, reject) {
  if (serviceOptions.axios) {
    return serviceOptions.axios.request(configs).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err);
    });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}
export function getConfigs(method, contentType, url, options) {
  const configs = {
    ...options,
    method,
    url
  };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType
  };
  return configs;
}
const basePath = '/api';
export class ListResultDto {}
export class PagedResultDto {}

// customer definition
// empty

export class CustomerService {
  /**
   * Search for customers using customer data.
   */
  static customerSearch(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/search';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get data for a single customer.
   */
  static getCustomer(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Edit customer
   */
  static editCustomer(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('put', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Filter and retrieve invoices for a single customer.
   */
  static getInvoices(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}/invoices';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Fetch user info from Signicat
   */
  static fetchSignicatUserInfo(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/signicatData/fetch';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Fetch person data using Signicat token
   */
  static getPersonData(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/personData';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Filter and retrieve transactions for a single customer.
   */
  static getTransactions(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}/transactions';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Filter and retrieve passings for a single customer.
   */
  static getPassings(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}/passings';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Filter and retrieve uninvoiced passings for a single customer.
   */
  static getUninvoicedPassings(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}/passings/uninvoiced';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get all customers the current user has access to
   */
  static getCustomersByAccessToken(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customers';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get a list of all existing Customer Groups
   */
  static getCustomerGroups(options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customerGroups';
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Create new customer
   */
  static createNewCustomer(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/create';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class CustomerInvoicesUnpaidService {
  /**
   * Get unpaid invoices by customerId
   */
  static getUnpaidInvoicesByCustomerId(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}/invoices/unpaid';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class CustomerInvoicesPaidService {
  /**
   * Get paid invoices by customerId
   */
  static getPaidInvoicesByCustomerId(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}/invoices/paid';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class AccountService {
  /**
   * Create account with a CustomerId Guid.
   */
  static createAccount(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/account/create';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class AgreementsService {
  /**
   * Get agreements for a customer.
   */
  static getAgreementsForCustomer(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}/agreements';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get agreements with its vehicles for a customer.
   */
  static getAgreementsWithObEsAndVehiclesForCustomer(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}/agreementsWithOBEsAndVehicles';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Search for agreements.
   */
  static agreementSearch(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agreement/search';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get agreement by ID
   */
  static getAgreementById(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agreement/{agreementId}';
      url = url.replace('{agreementId}', params['agreementId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Edit Agreement
   */
  static editAgreement(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agreement/{agreementId}';
      url = url.replace('{agreementId}', params['agreementId'] + '');
      const configs = getConfigs('patch', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Manually trigger invoice generation for the agreement.
   */
  static generateInvoice(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agreement/{agreementId}/generateInvoice';
      url = url.replace('{agreementId}', params['agreementId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Reject agreement
   */
  static rejectAgreement(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agreement/{agreementId}/reject';
      url = url.replace('{agreementId}', params['agreementId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Approve agreement
   */
  static approveAgreements(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agreement/approve';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Cancel agreement
   */
  static cancelAgreement(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agreement/cancel';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class AgreementsInvoicesService {
  /**
   * Get Invoices by AgreementID
   */
  static getInvoicesByAgreementId(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agreement/{agreementId}/invoices';
      url = url.replace('{agreementId}', params['agreementId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class AgreementsInvoicesUnpaidService {
  /**
   * Get unpaid invoices by AgreementID
   */
  static getUnpaidInvoicesByAgreementId(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agreement/{agreementId}/invoices/unpaid';
      url = url.replace('{agreementId}', params['agreementId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class AgreementsPassingsService {
  /**
   * Get passings by AgreementID
   */
  static getPassingsByAgreementId(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agreement/{agreementId}/passings';
      url = url.replace('{agreementId}', params['agreementId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class InvoicePassingsService {
  /**
   * Get passings by InvoiceId
   */
  static getPassingsByInvoiceId(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invoice/{invoiceId}/passings';
      url = url.replace('{invoiceId}', params['invoiceId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class InvoiceService {
  /**
   * Get invoices by account id and status
   */
  static getInvoicesByAccountIdAndStatus(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invoices/getByAccountIdAndStatus';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get details about an invoice using invoice number.
   */
  static getInvoice(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invoice/{invoiceNumber}';
      url = url.replace('{invoiceNumber}', params['invoiceNumber'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Activate blocking of dunning actions
   */
  static blockDunning(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invoice/{invoiceNumber}/blockDunning';
      url = url.replace('{invoiceNumber}', params['invoiceNumber'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Deactivate blocking of dunning actions
   */
  static unblockDunning(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invoice/{invoiceNumber}/unblockDunning';
      url = url.replace('{invoiceNumber}', params['invoiceNumber'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Postpone duedate
   */
  static postponeInvoiceDueDate(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/UpdateInvoiceDueDate';
      const configs = getConfigs('put', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Download attachment
   */
  static getInvoiceAttachment(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invoice/attachment/{fileName}';
      url = url.replace('{fileName}', params['fileName'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Search for legacy invoices from TietoEvry
   */
  static searchLegacyInvoices(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invoice/legacyInvoices';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get PDF of legacy invoice.
   */
  static getInvoice1(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invoice/legacyInvoices/{documentId}/pdf';
      url = url.replace('{documentId}', params['documentId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Request payment link from Fair
   */
  static requestPaymentLink(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invoice/{invoiceNumber}/payment-link';
      url = url.replace('{invoiceNumber}', params['invoiceNumber'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class ObeService {
  /**
   * Get OBEs for a customer
   */
  static getObesWithQuery(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/obe/getByCustomerId/{customerId}';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get OBEs for a customer
   */
  static getObes(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/obe/getByCustomerId/{customerId}';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get OBE details for a OBE
   */
  static getObeDetails(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/obe/{obeNumber}';
      url = url.replace('{obeNumber}', params['obeNumber'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get OBE for an active vehicle by registration number and country code
   */
  static getObeByVehicleRegNumberAndCountryCode(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/obe/getByVehicleNumberAndCountryCode/{vehicleRegNumber}/{countryCode}';
      url = url.replace('{vehicleRegNumber}', params['vehicleRegNumber'] + '');
      url = url.replace('{countryCode}', params['countryCode'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Claim OBE deposit
   */
  static claimDeposit(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/obe/claimDeposit';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get OBE by agreement ID
   */
  static getObesByAgreementId(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/obe/getByAgreementId/{agreementId}';
      url = url.replace('{agreementId}', params['agreementId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get vehicle information from vehicle registry
   */
  static getVehicleInformation(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/obe/GetVehicleInformation';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get inactive OBEs
   */
  static getInactiveObes(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}/obes/inactive';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Replace an OBE
   */
  static replaceObe(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/obe/replace';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Whether the obe is set to be moved to a not yet approved agreement
   */
  static obeIsBeingMoved(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/obe/isBeingMoved/{obeId}';
      url = url.replace('{obeId}', params['obeId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Terminates an inactive OBE
   */
  static terminateInactiveObe(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/obe/disableInactiveFrozen';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class DepositService {
  /**
   * Get current customer deposit
   */
  static getCustomerDeposit(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}/deposit';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Accept an offered financial security deposit
   */
  static acceptDeposit(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}/creditAssessments/{creditAssessmentId}/registration';
      url = url.replace('{customerId}', params['customerId'] + '');
      url = url.replace('{creditAssessmentId}', params['creditAssessmentId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Reject an offered financial security deposit
   */
  static rejectDeposit(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}/creditAssessments/{creditAssessmentId}/registration/reject';
      url = url.replace('{customerId}', params['customerId'] + '');
      url = url.replace('{creditAssessmentId}', params['creditAssessmentId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class CreditCardService {
  /**
   * Get credit card fee from configurations
   */
  static getCreditCardFee(options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/configuration/getCreditCardFee';
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class PaymentService {
  /**
   * Submit manual payment
   */
  static manualPayment(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/manualPayment/{agreementId}';
      url = url.replace('{agreementId}', params['agreementId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class CaseService {
  /**
   * Get case by id
   */
  static getCase(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/case/{caseId}';
      url = url.replace('{caseId}', params['caseId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Search for cases using case type.
   */
  static caseSearch(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/case/search';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Create new case.
   */
  static createCase(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/case/create';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Update existing case.
   */
  static updateCase(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/case/{caseId}/update';
      url = url.replace('{caseId}', params['caseId'] + '');
      const configs = getConfigs('patch', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Gets a case with all its comments.
   */
  static getCaseWithComments(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/case/{caseId}/comments';
      url = url.replace('{caseId}', params['caseId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Searches comments related to a case.
   */
  static searchCommentsForCase(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/case/{caseId}/comments';
      url = url.replace('{caseId}', params['caseId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Creates a new case comment
   */
  static createCommentForCase(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/case/{caseId}/comment/create';
      url = url.replace('{caseId}', params['caseId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Gets a specific case comment.
   */
  static getCaseComment(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/case/comment/{caseCommentId}';
      url = url.replace('{caseId}', params['caseId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Creates a new case comment attachment
   */
  static createCaseCommentAttachment(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/case/comment/{caseCommentId}/attachment/create';
      url = url.replace('{caseCommentId}', params['caseCommentId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Download case comment attachment
   */
  static downloadCaseCommentAttachmentById(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/case/comment/attachment/{caseCommentAttachmentId}/download';
      url = url.replace('{caseCommentAttachmentId}', params['caseCommentAttachmentId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get case comment attachment
   */
  static getCaseCommentAttachmentById(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/case/comment/attachment/{caseCommentAttachmentId}';
      url = url.replace('{caseCommentAttachmentId}', params['caseCommentAttachmentId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Complete unknown payment
   */
  static completeUnknownPayment(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/case/{caseId}/completeUnknownPayment';
      url = url.replace('{caseId}', params['caseId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class PassingsService {
  /**
   * Get passing by ID
   */
  static getPassingById(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/passing/{passingId}';
      url = url.replace('{passingId}', params['passingId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Filter and retrieve passings for a given OBE number.
   */
  static getPassingsForObe(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/passings/{obeNumber}';
      url = url.replace('{obeNumber}', params['obeNumber'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Filter and retrieve passings for a list of OBE numbers.
   */
  static getPassingsForObes(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/obes/passings';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Whether the customer has archived passings
   */
  static customerHasArchivedPassings(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/transactions/archive/customerHasArchivedPassings/{customerId}';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class VehicleService {
  /**
   * Register vehicle and move OBE
   */
  static registerVehicleAndMoveObe(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/vehicle/registerVehicleAndMoveObe';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Register vehicle and transfer existing OBE to it
   */
  static registerVehicleWithObe(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/vehicle/registerWithObe';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Gets vehicle by its registration number and country code
   */
  static getVehicleByRegNumberAndCountryCode(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/vehicle/getByRegNumberAndCountryCode/{regNumber}/{countryCode}';
      url = url.replace('{regNumber}', params['regNumber'] + '');
      url = url.replace('{countryCode}', params['countryCode'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Register vehicles on an existing agreement
   */
  static registerVehicles(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/vehicles/register';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Register vehicles and create a new agreement
   */
  static registerVehiclesAndCreateAgreement(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/vehicles/registerAndCreateAgreement';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Unregister vehicles and remove or keep OBE, option in Request body
   */
  static unregisterVehicles(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/vehicles/unregister';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Check if an LPN-Country code combo is currently awaiting shipping
   */
  static isVehicleAwaitingShipping(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/vehicle/isAwaitingShipping';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Check if the provided vehicle is already attached to an OBE
   */
  static isVehicleAlreadyRegistered(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/vehicle/isAlreadyRegistered/{regNumber}/{countryCode}';
      url = url.replace('{regNumber}', params['regNumber'] + '');
      url = url.replace('{countryCode}', params['countryCode'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Check if the provided vehicle is already registered and being moved
   */
  static isRegisteredVehicleBeingMoved(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/vehicle/IsRegisteredVehicleBeingMoved/{regNumber}/{countryCode}';
      url = url.replace('{regNumber}', params['regNumber'] + '');
      url = url.replace('{countryCode}', params['countryCode'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class ObeVehicleService {
  /**
   * Move OBE from one vehicle to another and/or to another agreement
   */
  static moveObe(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/obe/move';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class CompanyOrganizationService {
  /**
   * Search in company registry (Brønnøysundregistrene)
   */
  static searchOrganizationInformation(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/organization-information';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class PeopleRegistryService {
  /**
   * Check in people registry (DSF) if given person exists
   */
  static checkIfPersonExists(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/checkIfPersonExists';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Try to fetch person data from DSF
   */
  static fetchPerson(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/tryFetchPerson';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class ShippingService {
  /**
   * Get order by id
   */
  static getOrder(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/shipping/orders/{orderId}';
      url = url.replace('{orderId}', params['orderId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get label by order id
   */
  static getOrderLabel(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/shipping/orders/{orderId}/label';
      url = url.replace('{orderId}', params['orderId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      configs.params = {
        obeNumber: params['obeNumber']
      };
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Search for orders using order type.
   */
  static searchOrder(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/shipping/orders/search';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class RemittanceService {
  /**
   * Create new remittance
   */
  static createManualRemittance(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/remittance/create';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Edit remittance
   */
  static editRemittance(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/remittance/edit';
      const configs = getConfigs('patch', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Approve remittance
   */
  static approveRemittance(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/remittance/approve';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Reject remittance
   */
  static rejectRemittance(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/remittance/reject';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class TransactionsService {
  /**
   * Get transaction by ID
   */
  static getTransactionById(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/transaction/{transactionId}';
      url = url.replace('{transactionId}', params['transactionId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get transaction by ID for Case Details
   */
  static getRemittanceTransactionForCaseDetailsById(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/case/transaction/{transactionId}';
      url = url.replace('{transactionId}', params['transactionId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class CreditingService {
  /**
   * Creates a CreditNote case.
   */
  static creditInvoiceLines(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invoices/creditInvoiceLines';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Approves or rejects a CreditNote request.
   */
  static approveRejectCreditNoteCase(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invoices/creditInvoiceLines/decide';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class UserService {
  /**
   * Get user by accessToken
   */
  static getUserByAccessToken(options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/user/getByAccessToken';
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Register a new user
   */
  static registerUser(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/user/register';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class TestService {
  /**
   * Just for testing auth - might delete later
   */
  static testAuth(options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/authtest';
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class PrivilegeService {
  /**
   * Activate a privilege for a user
   */
  static activatePrivilege(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/privilege/activate';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Activate privileges for a user by supplying an email
   */
  static grantPrivilegesByEmail(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/privilege/grantByEmail';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Grant privilege to user
   */
  static grantPrivilege(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/privilege/grant';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Revoke privilege
   */
  static revokePrivilege(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/privilege/revokeById/{privilegeId}';
      url = url.replace('{privilegeId}', params['privilegeId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Search privileges for customer
   */
  static searchPrivileges(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/privilege/search/{customerId}';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Search privileges for customer pending activation
   */
  static searchPendingPrivileges(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/privilege/pending/search/{customerId}';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get privileges for customer
   */
  static getPrivileges(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/privilege/customer/{customerId}';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Deactivate the grant access token with the given id
   */
  static deactivateGrantAccessToken(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/privilege/pending/deactivateById/{pendingPrivilegeId}';
      url = url.replace('{pendingPrivilegeId}', params['pendingPrivilegeId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class LocalAgreementService {
  /**
   * The latest local agreements for a customer with the given customer id
   */
  static getLatestLocalAgreementsByCustomerId(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}/latestExternalSubscriptions';
      url = url.replace('{customerId}', params['customerId'] + '');
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class CustomersService {
  /**
   * Check if organization number already exists
   */
  static doesCustomerExistByOrgNumber(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/doesExistByOrgNumber/{orgNumber}';
      url = url.replace('{orgNumber}', params['orgNumber'] + '');
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class SubscriptionsService {
  /**
   * Edits the subscription for the provided OBE.
   */
  static editSubscriptionForObe(params = {}, options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/subscriptions/obe/edit';
      const configs = getConfigs('post', 'application/json', url, options);
      let data = params['body'];
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export class ConfigurationService {
  /**
   * Get sanctioned countries
   */
  static getSanctionedCountries(options = {}) {
    return new Promise((resolve, reject) => {
      let url = basePath + '/configuration/sanctioned-countries';
      const configs = getConfigs('get', 'application/json', url, options);
      let data = null;
      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
export let EnumAgreementStatus;
(function (EnumAgreementStatus) {
  EnumAgreementStatus["New"] = "New";
  EnumAgreementStatus["Active"] = "Active";
  EnumAgreementStatus["Inactive"] = "Inactive";
  EnumAgreementStatus["Frozen"] = "Frozen";
  EnumAgreementStatus["AwaitingApproval"] = "AwaitingApproval";
  EnumAgreementStatus["ApprovedAwaitingShipping"] = "ApprovedAwaitingShipping";
  EnumAgreementStatus["Rejected"] = "Rejected";
  EnumAgreementStatus["Cancelled"] = "Cancelled";
  EnumAgreementStatus["Terminated"] = "Terminated";
  EnumAgreementStatus["AwaitingDeactivation"] = "AwaitingDeactivation";
})(EnumAgreementStatus || (EnumAgreementStatus = {}));
export let EnumCustomerCustomerStatus;
(function (EnumCustomerCustomerStatus) {
  EnumCustomerCustomerStatus["Active"] = "Active";
  EnumCustomerCustomerStatus["Frozen"] = "Frozen";
  EnumCustomerCustomerStatus["Inactive"] = "Inactive";
})(EnumCustomerCustomerStatus || (EnumCustomerCustomerStatus = {}));
export let CustomerType;
(function (CustomerType) {
  CustomerType["Person"] = "Person";
  CustomerType["Company"] = "Company";
})(CustomerType || (CustomerType = {}));
export let EnumGetObeDetailsResultDepositStatus;
(function (EnumGetObeDetailsResultDepositStatus) {
  EnumGetObeDetailsResultDepositStatus["Requested"] = "Requested";
  EnumGetObeDetailsResultDepositStatus["Paid"] = "Paid";
  EnumGetObeDetailsResultDepositStatus["Returned"] = "Returned";
  EnumGetObeDetailsResultDepositStatus["RecordedAsRevenue"] = "RecordedAsRevenue";
  EnumGetObeDetailsResultDepositStatus["PartialReturned"] = "PartialReturned";
})(EnumGetObeDetailsResultDepositStatus || (EnumGetObeDetailsResultDepositStatus = {}));
export let EnumUpdateObeRequestObeStatus;
(function (EnumUpdateObeRequestObeStatus) {
  EnumUpdateObeRequestObeStatus["New"] = "New";
  EnumUpdateObeRequestObeStatus["Active"] = "Active";
  EnumUpdateObeRequestObeStatus["Inactive"] = "Inactive";
  EnumUpdateObeRequestObeStatus["Shipped"] = "Shipped";
  EnumUpdateObeRequestObeStatus["Frozen"] = "Frozen";
  EnumUpdateObeRequestObeStatus["Lost"] = "Lost";
  EnumUpdateObeRequestObeStatus["Terminated"] = "Terminated";
})(EnumUpdateObeRequestObeStatus || (EnumUpdateObeRequestObeStatus = {}));
export let EnumUpdateObeRequestExemptionCode;
(function (EnumUpdateObeRequestExemptionCode) {
  EnumUpdateObeRequestExemptionCode["NoExemption"] = "NoExemption";
  EnumUpdateObeRequestExemptionCode["Handicap"] = "Handicap";
  EnumUpdateObeRequestExemptionCode["BusInRoute"] = "BusInRoute";
  EnumUpdateObeRequestExemptionCode["Maxitaxi"] = "Maxitaxi";
})(EnumUpdateObeRequestExemptionCode || (EnumUpdateObeRequestExemptionCode = {}));
export let VehicleSize;
(function (VehicleSize) {
  VehicleSize["Heavy"] = "Heavy";
  VehicleSize["Regular"] = "Regular";
})(VehicleSize || (VehicleSize = {}));
export let EnumRegistrationStatus;
(function (EnumRegistrationStatus) {
  EnumRegistrationStatus["Completed"] = "Completed";
  EnumRegistrationStatus["DepositRequired"] = "DepositRequired";
  EnumRegistrationStatus["ManualReview"] = "ManualReview";
  EnumRegistrationStatus["Failed"] = "Failed";
  EnumRegistrationStatus["RegistrationPending"] = "RegistrationPending";
})(EnumRegistrationStatus || (EnumRegistrationStatus = {}));
export let OrderType;
(function (OrderType) {
  OrderType["Obe"] = "Obe";
  OrderType["ObeHolder"] = "ObeHolder";
  OrderType["BlankObe"] = "BlankObe";
})(OrderType || (OrderType = {}));
export let EnumOrderStatus;
(function (EnumOrderStatus) {
  EnumOrderStatus["Pending"] = "Pending";
  EnumOrderStatus["InProgress"] = "InProgress";
  EnumOrderStatus["Shipped"] = "Shipped";
})(EnumOrderStatus || (EnumOrderStatus = {}));
export let EnumTransactionItemType;
(function (EnumTransactionItemType) {
  EnumTransactionItemType["DepositPayout"] = "DepositPayout";
  EnumTransactionItemType["DunningCredit"] = "DunningCredit";
  EnumTransactionItemType["OverPayment"] = "OverPayment";
  EnumTransactionItemType["Passing"] = "Passing";
  EnumTransactionItemType["PaymentFromDeviationToLedger"] = "PaymentFromDeviationToLedger";
  EnumTransactionItemType["WriteOff"] = "WriteOff";
})(EnumTransactionItemType || (EnumTransactionItemType = {}));
export let EnumDepositOption;
(function (EnumDepositOption) {
  EnumDepositOption["AwaitReturn"] = "AwaitReturn";
  EnumDepositOption["Claim"] = "Claim";
  EnumDepositOption["Payout"] = "Payout";
})(EnumDepositOption || (EnumDepositOption = {}));
export let EnumArchiveStatus;
(function (EnumArchiveStatus) {
  EnumArchiveStatus["NotStarted"] = "NotStarted";
  EnumArchiveStatus["Uploaded"] = "Uploaded";
  EnumArchiveStatus["Verified"] = "Verified";
  EnumArchiveStatus["Deleted"] = "Deleted";
  EnumArchiveStatus["FailedToUpload"] = "FailedToUpload";
  EnumArchiveStatus["FailedToVerify"] = "FailedToVerify";
  EnumArchiveStatus["FailedToDelete"] = "FailedToDelete";
})(EnumArchiveStatus || (EnumArchiveStatus = {}));
export let OperationType;
(function (OperationType) {
  OperationType["Credit"] = "Credit";
  OperationType["Debit"] = "Debit";
})(OperationType || (OperationType = {}));
export let CaseType;
(function (CaseType) {
  CaseType["CustomerInquiry"] = "CustomerInquiry";
  CaseType["InvalidTransactionAuthor"] = "InvalidTransactionAuthor";
  CaseType["NewCustomer"] = "NewCustomer";
  CaseType["NewAgreement"] = "NewAgreement";
  CaseType["NewVehicle"] = "NewVehicle";
  CaseType["VehicleChange"] = "VehicleChange";
  CaseType["TerminateAgreement"] = "TerminateAgreement";
  CaseType["DebtCollectionFailure"] = "DebtCollectionFailure";
  CaseType["ObeReturned"] = "ObeReturned";
  CaseType["ObeReplaced"] = "ObeReplaced";
  CaseType["ObeStopped"] = "ObeStopped";
  CaseType["InvoiceDispute"] = "InvoiceDispute";
  CaseType["RemittanceRequest"] = "RemittanceRequest";
  CaseType["PaymentLost"] = "PaymentLost";
  CaseType["AutomatedRemittance"] = "AutomatedRemittance";
  CaseType["ManualRemittance"] = "ManualRemittance";
  CaseType["CancelAgreement"] = "CancelAgreement";
  CaseType["ClaimDeposit"] = "ClaimDeposit";
  CaseType["CreditNote"] = "CreditNote";
  CaseType["DunningBlocked"] = "DunningBlocked";
})(CaseType || (CaseType = {}));
export let CaseStatus;
(function (CaseStatus) {
  CaseStatus["New"] = "New";
  CaseStatus["InProgress"] = "InProgress";
  CaseStatus["Paused"] = "Paused";
  CaseStatus["Closed"] = "Closed";
})(CaseStatus || (CaseStatus = {}));
export let EnumRemittanceTransactionRemittanceStatus;
(function (EnumRemittanceTransactionRemittanceStatus) {
  EnumRemittanceTransactionRemittanceStatus["Resolved"] = "Resolved";
  EnumRemittanceTransactionRemittanceStatus["Unresolved"] = "Unresolved";
  EnumRemittanceTransactionRemittanceStatus["NotApproved"] = "NotApproved";
  EnumRemittanceTransactionRemittanceStatus["Failed"] = "Failed";
})(EnumRemittanceTransactionRemittanceStatus || (EnumRemittanceTransactionRemittanceStatus = {}));
export let EnumGrantPrivilegeRequestPrivilegeType;
(function (EnumGrantPrivilegeRequestPrivilegeType) {
  EnumGrantPrivilegeRequestPrivilegeType["FULL_ACCESS"] = "FULL_ACCESS";
})(EnumGrantPrivilegeRequestPrivilegeType || (EnumGrantPrivilegeRequestPrivilegeType = {}));
export let EnumPendingPrivilegeResultPrivilegeType;
(function (EnumPendingPrivilegeResultPrivilegeType) {
  EnumPendingPrivilegeResultPrivilegeType["FULL_ACCESS"] = "FULL_ACCESS";
})(EnumPendingPrivilegeResultPrivilegeType || (EnumPendingPrivilegeResultPrivilegeType = {}));
export let EnumPrivilegePrivilegeType;
(function (EnumPrivilegePrivilegeType) {
  EnumPrivilegePrivilegeType["FULL_ACCESS"] = "FULL_ACCESS";
})(EnumPrivilegePrivilegeType || (EnumPrivilegePrivilegeType = {}));
export let EnumInvoiceStatus;
(function (EnumInvoiceStatus) {
  EnumInvoiceStatus["Pending"] = "Pending";
  EnumInvoiceStatus["ExternalDebtCollection"] = "ExternalDebtCollection";
  EnumInvoiceStatus["Paid"] = "Paid";
  EnumInvoiceStatus["PaymentRequested"] = "PaymentRequested";
  EnumInvoiceStatus["PaymentFailed"] = "PaymentFailed";
  EnumInvoiceStatus["Cancelled"] = "Cancelled";
  EnumInvoiceStatus["Credited"] = "Credited";
  EnumInvoiceStatus["PaymentRevoked"] = "PaymentRevoked";
  EnumInvoiceStatus["PaymentReminderSent"] = "PaymentReminderSent";
  EnumInvoiceStatus["ClosedByDebtCollector"] = "ClosedByDebtCollector";
  EnumInvoiceStatus["CreditRejected"] = "CreditRejected";
  EnumInvoiceStatus["CreditNote"] = "CreditNote";
  EnumInvoiceStatus["PaidByBalance"] = "PaidByBalance";
  EnumInvoiceStatus["Remittance"] = "Remittance";
  EnumInvoiceStatus["Preparing"] = "Preparing";
  EnumInvoiceStatus["PreparingDistribution"] = "PreparingDistribution";
  EnumInvoiceStatus["SentToDistribution"] = "SentToDistribution";
  EnumInvoiceStatus["AwaitingDelivery"] = "AwaitingDelivery";
  EnumInvoiceStatus["Initial"] = "Initial";
  EnumInvoiceStatus["ValidationError"] = "ValidationError";
  EnumInvoiceStatus["DocumentError"] = "DocumentError";
  EnumInvoiceStatus["PaymentRegistered"] = "PaymentRegistered";
})(EnumInvoiceStatus || (EnumInvoiceStatus = {}));
export let EnumCsvAndPdf;
(function (EnumCsvAndPdf) {
  EnumCsvAndPdf["csv"] = "csv";
  EnumCsvAndPdf["pdf"] = "pdf";
})(EnumCsvAndPdf || (EnumCsvAndPdf = {}));